module.exports = __webpack_public_path__ + "assets/img/bg-credits.599dd3c3.png";